/**
 * @generated SignedSource<<6296fb9bdf290ff408e8bf367aa8228b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type MessageType = "REACTION" | "SYSTEM" | "USER" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type CommentsThread_chat_socialThread$data = {
  readonly comments: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly createdAt: ISO8601DateTimeString;
        readonly deletedAt: ISO8601DateTimeString | null;
        readonly id: string;
        readonly isEdited: boolean;
        readonly senderId: string | null;
        readonly text: UnknownJSON;
        readonly type: MessageType;
        readonly updatedAt: ISO8601DateTimeString;
        readonly " $fragmentSpreads": FragmentRefs<"AnnouncementMessageActions_chat_messageFragment" | "EditAnnouncementMessage_chat_messageFragment" | "MessageReactions_chat_messageFragment" | "ReactionButton_chat_messageFragment">;
      };
    }>;
  };
  readonly id: string;
  readonly participantsIds: ReadonlyArray<string>;
  readonly reference: string;
  readonly " $fragmentType": "CommentsThread_chat_socialThread";
};
export type CommentsThread_chat_socialThread$key = {
  readonly " $data"?: CommentsThread_chat_socialThread$data;
  readonly " $fragmentSpreads": FragmentRefs<"CommentsThread_chat_socialThread">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "comments"
        ]
      }
    ]
  },
  "name": "CommentsThread_chat_socialThread",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "reference",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "participantsIds",
      "storageKey": null
    },
    {
      "alias": "comments",
      "args": null,
      "concreteType": "CommentsConnection",
      "kind": "LinkedField",
      "name": "__CommentsThread_comments_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CommentsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Message",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "type",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "senderId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "text",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "createdAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "deletedAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isEdited",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "updatedAt",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "MessageReactions_chat_messageFragment"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ReactionButton_chat_messageFragment"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "EditAnnouncementMessage_chat_messageFragment"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "AnnouncementMessageActions_chat_messageFragment"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SocialThread",
  "abstractKey": null
};
})();

(node as any).hash = "4e5315047defde33f0bf1965852a449a";

export default node;
